import { BackgroundExportTypes } from 'further-types/background-exports';
import { BackgroundExportTypeLabels } from '../../labels';
import { CalendarTime } from '../../utils';

const getDownloadTitle = (download: {
  exportType?: BackgroundExportTypes;
  createdAt?: CalendarTime;
  firmName?: string;
  additionalLabel?: string;
}) => {
  if (!download.exportType || !download.createdAt) {
    return '';
  }

  const time = download.createdAt.toLabel('N/A', 'HH:mm');
  let label = BackgroundExportTypeLabels[download.exportType];

  if (download.additionalLabel) {
    label += ` ${download.additionalLabel}`;
  }

  label += ` - ${time}`;

  return label;
};

export default getDownloadTitle;
